import React from 'react';
import { ShieldCheck, Target } from 'lucide-react';
const CONTENT_IMG = 'https://cdn.magicpatterns.com/uploads/cm2dF27V2JyW3M21uejgG8/Crisis-Planning.png';
export function MainContentSection() {
  return <section className="py-16 md:py-24 bg-brand-black" data-id="element-493">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-494">
        {/* Featured Image */}
        <div className="max-w-4xl mx-auto mb-20" data-id="element-495">
          <div className="relative p-2 border border-brand-gray-700 bg-brand-gray-900" data-id="element-496">
            <img src={CONTENT_IMG} alt="Strategic Planning for Crisis Situations" className="block w-full h-auto object-cover" data-id="element-497" />
            <div className="absolute top-0 left-0 w-4 h-4 border-t-2 border-l-2 border-brand-teal z-10" data-id="element-498" />
            <div className="absolute top-0 right-0 w-4 h-4 border-t-2 border-r-2 border-brand-teal z-10" data-id="element-499" />
            <div className="absolute bottom-0 left-0 w-4 h-4 border-b-2 border-l-2 border-brand-teal z-10" data-id="element-500" />
            <div className="absolute bottom-0 right-0 w-4 h-4 border-b-2 border-r-2 border-brand-teal z-10" data-id="element-501" />
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start" data-id="element-502">
          {/* Strategic Preparedness */}
          <div className="bg-brand-gray-900 p-8 md:p-10 border border-brand-gray-800 h-full" data-id="element-503">
            <div className="w-12 h-12 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center mb-8" data-id="element-504">
              <ShieldCheck className="w-6 h-6 text-brand-teal" data-id="element-505" />
            </div>
            <h2 className="text-2xl font-bold text-brand-white uppercase tracking-wide mb-6" data-id="element-506">
              Strategic Preparedness for Critical Incidents
            </h2>
            <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-507">
              <p data-id="element-508">
                For many law enforcement agencies and corporate organizations,
                preparation and planning for critical incidents often take a
                back seat—until a crisis arises. Our team of highly experienced
                consultants specializes in evaluating your existing policies,
                identifying potential gaps, and implementing strategic
                enhancements to ensure your organization remains fully prepared.
              </p>
              <p data-id="element-509">
                We offer comprehensive policy development, continuous updates,
                and the creation of advanced operational plans that integrate
                the latest methodologies and cutting-edge technologies tailored
                to your specific needs. If your current plans require
                modernization or optimization, we are here to help. Contact us
                today to take a proactive approach to risk management.
              </p>
            </div>
          </div>

          {/* Proactive Strategy */}
          <div className="bg-brand-gray-900 p-8 md:p-10 border border-brand-gray-800 h-full" data-id="element-510">
            <div className="w-12 h-12 bg-brand-teal/10 border border-brand-teal/30 flex items-center justify-center mb-8" data-id="element-511">
              <Target className="w-6 h-6 text-brand-teal" data-id="element-512" />
            </div>
            <h2 className="text-2xl font-bold text-brand-white uppercase tracking-wide mb-6" data-id="element-513">
              Proactive Strategy Development for Operational Readiness
            </h2>
            <div className="prose prose-invert prose-lg text-brand-gray-300 leading-relaxed" data-id="element-514">
              <p data-id="element-515">
                Developing effective crisis response strategies can be
                challenging, particularly in industries where critical incidents
                occur infrequently. This lack of immediate crisis exposure often
                results in outdated or insufficient preparedness measures. Our
                team ensures that your organization remains ahead of potential
                threats by designing, refining, and implementing
                forward-thinking strategies that yield tangible, positive
                outcomes when critical moments arise.
              </p>
              <p data-id="element-516">
                We provide tailored operational plans, ensuring that you and
                your staff remain well-informed, fully equipped, and always
                ready to respond effectively. By leveraging industry-leading
                expertise and the most current strategic advancements, we help
                you maintain a state of readiness that minimizes risks and
                maximizes efficiency.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}